// Reopen Shopify's existing consent panel without changing consent on the
// visitor's behalf or installing a second consent system.
const buttons = document.querySelectorAll('[data-ts-cookie-preferences]');
function connect() {
  if (typeof window.privacyBanner?.showPreferences !== 'function') return;
  for (const button of buttons) {
    if (button.dataset.connected) continue;
    button.dataset.connected = 'true';
    button.hidden = false;
    button.addEventListener('click', async () => {
      button.disabled = true;
      try { await window.privacyBanner.showPreferences(); }
      catch { button.closest('li').querySelector('[role=status]').hidden = false; }
      finally { button.disabled = false; }
    });
  }
}
connect();
window.addEventListener('load', connect, { once: true });
document.querySelector('script[src*="privacy-banner/storefront-banner.js"]')?.addEventListener('load', connect, { once: true });


// Shopify's consent banner may use the primary domain for its policy link.
// Keep this link on the current storefront and in the selected language.
function localizePrivacyLink() {
  const link = document.getElementById('shopify-pc__banner__body-policy-link');
  if (!link) return false;
  const root = window.Shopify?.routes?.root || '/';
  const path = `${root.replace(/\/$/, '')}/policies/privacy-policy`;
  const url = new URL(path, window.location.origin);
  if (link.href !== url.href) link.href = url.href;
  return true;
}
if (!localizePrivacyLink()) {
  const bannerObserver = new MutationObserver(() => {
    if (localizePrivacyLink()) bannerObserver.disconnect();
  });
  bannerObserver.observe(document.documentElement, { childList: true, subtree: true });
}
